import React from "react";
import { HashRouter, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home";
import Input from "./components/Input";
import Initial from "./components/Initial";
import DecryptionView from "./components/decryptionView";
import Rounds from "./components/rounds";
import DisplayBox from "./components/DisplayBox";
import DisplayBox64Bit from "./components/displayBox64Bit";
import DisplayTBox from "./components/DisplayTextBox";
import Page1 from "./components/Page1";
import Keygen from "./components/Keygen";
import Final from "./components/FinalPermutation";


function App() {
  return (
    <HashRouter>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/input" element={<Input />} />
          <Route path="/initial" element={<Initial />} />
          <Route path="/decryptionView" element={<DecryptionView />}/>
          <Route path="/rounds" element={<Rounds />}/>
          <Route path="/DisplayBox" element={<DisplayBox />} />
          <Route path="/DisplayTextBox" element={<DisplayTBox />} />
          <Route path="/DisplayBox64Bit" element={<DisplayBox64Bit />} />
          <Route path="/page1" element={<Page1 />} />
          <Route path="/keygen" element={<Keygen />} />
          <Route path="/keygen" element={<Keygen />} />
          <Route path="/final" element={<Final />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
